import ApiUrls from "../helper/api-urls";
import ApiHelper from "../helper/api-helper";


const getRoles = () => {
  return ApiHelper.getRequest(ApiUrls.GET_ROLES + 1);
};

const getRoleModules = (id) => {
  return ApiHelper.getRequest(
    ApiUrls.GET_ROLE_MODULE_PERMISSION_ACCESS + id + "&" + "regionId" + "=" + 1
  );
};

const updateRoleModulePermission = (roleId, selectedPermissions) => {
  var data = {
    regionId: 1,
    roleId: roleId,
    permissions: selectedPermissions,
    isDefaultPermissions: true,
  };

  return ApiHelper.postRequest(ApiUrls.UPDATE_ROLE_PERMISSION, data);
};

export const RoleService = {
  getRoles,
  getRoleModules,
  updateRoleModulePermission,
};
